/**
 * @generated SignedSource<<16aef57c8c5c7c229626811442ce9d3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GetVideoDataV2Input = {
  clientMutationId?: string | null;
  vimeoId: string;
  vimeoVideoSourceId: string;
};
export type videoSourceField_GetVideoDataV2Mutation$variables = {
  input: GetVideoDataV2Input;
};
export type videoSourceField_GetVideoDataV2Mutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly getVideoData: {
        readonly videoData: {
          readonly duration: number;
          readonly name: string;
          readonly thumbnailUrl: string;
        } | null;
      } | null;
    };
  };
};
export type videoSourceField_GetVideoDataV2Mutation = {
  response: videoSourceField_GetVideoDataV2Mutation$data;
  variables: videoSourceField_GetVideoDataV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElearningV2AdminMutationSchema",
        "kind": "LinkedField",
        "name": "ElearningV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "GetVideoDataV2Payload",
            "kind": "LinkedField",
            "name": "getVideoData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoDataV2",
                "kind": "LinkedField",
                "name": "videoData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "videoSourceField_GetVideoDataV2Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "videoSourceField_GetVideoDataV2Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7998db7209ac2047348780c10655c9a1",
    "id": null,
    "metadata": {},
    "name": "videoSourceField_GetVideoDataV2Mutation",
    "operationKind": "mutation",
    "text": "mutation videoSourceField_GetVideoDataV2Mutation(\n  $input: GetVideoDataV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      getVideoData(input: $input) {\n        videoData {\n          name\n          duration\n          thumbnailUrl\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1abb7c79434fb7a8b16fd82b728d9f77";

export default node;
